const useFormatPrice = () => {
  const formatPrice = price => {
    return price.toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
    })
  }
  return formatPrice
}

export default useFormatPrice
